export const TopTodoCardId = "topTodoCard";
export const BetweenCardsContentId = "betweenCardsContent";
export const MainContentToggleId = "mainContentToggle";
export const MainCardContentContainerId = "mainCardContentContainer";
export const MainCardContentId = "mainCardContent";
export const InfoViwerContentContainerId = "infoViwerContentContainer";
export const InfoViewerSmallId = "infoViewerSmall";
export const OtherContentId = "otherContent";
export const FooterId = "footer";
export const InfoViewerId = "infoViewer";
